import { observer } from "mobx-react"
import { useEffect, useMemo } from "react"

var Requester: Array<string> = []

type ExtraHeaderTypes = {
  id: string
  type?: "script" | "link"
  target: "head" | "body"
  src?: string
  async?: boolean
  defer?: boolean
  text?: string
  delay?: number
  onLoadFn?: Function
}

const LazyScript = observer(({ id, type = "script", target = "head", src = "", async = false, defer = false, text = "", delay = 0, onLoadFn }: ExtraHeaderTypes) => {
  useEffect(() => {
    console.info("Requester :", id, Requester, Requester.includes(id))

    if (!Requester.includes(id)) {
      Requester.push(id)
      console.info("LazyScript Debugger :", id, document.querySelector(`#${id}`))

      const script: HTMLScriptElement | any = document.createElement(type)

      if (type === "link" && src) Object.assign(script, { id, href: src, rel: "stylesheet", type: "text/css" })
      else if (type === "script" && src) Object.assign(script, { src, id })
      else if (type === "script" && text) Object.assign(script, { text, id })
      else Object.assign(script, { id })

      if (defer) {
        script.setAttribute("defer", "defer")
      }

      if (async) {
        script.setAttribute("async", "async")
      }

      let targetNode: any = document.querySelector(target)
      console.log("layscript.targetnode", id, targetNode)

      setTimeout(() => {
        targetNode.appendChild(script)
        console.info("LazyScript :", onLoadFn)
        if (typeof onLoadFn === "function") {
          if (script.readyState) {
            script.onreadystatechange = function () {
              if (script.readyState === "loaded" || script.readyState === "complete") {
                script.onreadystatechange = null
                onLoadFn()
              }
            }
          } else {
            script.onload = function () {
              onLoadFn()
            }
          }
        }
      }, delay)
    }

    return () => {
      // try {
      //   if (Requester.includes(id) && typeof id === "string") {
      //     document.querySelector(`#${id}`)?.remove()
      //   }
      // } catch {}
    }
  }, [id])

  return null
})

export default LazyScript
